

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseTransDocument } from './../entities/basetransdocument.entity';
import { BaseDocument } from './../entities/basedocument.entity';
export class AgingTransDocument extends BaseTransDocument
{   
    public AgingDays: number; 
    public TotalSum: number; 
    public OpenSumFeature: number; 
    public OpenSum1_30: number; 
    public OpenSum31_60: number; 
    public OpenSum61_90: number; 
    public OpenSum90_180: number; 
    public OpenSum180Plus: number; 
    public TotalSumFeature: number; 
    public TotalSum1_30: number; 
    public TotalSum31_60: number; 
    public TotalSum61_90: number; 
    public TotalSum90_180: number; 
    public TotalSum180Plus: number; 
	
}



